import { makeStyles } from "@mui/styles";

export const useStyles = makeStyles({
    input: {
        '&&': {
            width: '100%',
            fontFamily: `'Rubik', sans-serif`,
            fontSize: 16,
            color: 'white',
            textAlign: 'right'
        }
    },
    icon: {
        '&&': {
            cursor: 'pointer',
            transform: 'translateX(-20%)',
            fill: '#FFFFFF80',
            '&:hover': {
                fill: '#FFFFFF',
            }
        }
    },
    startAdornment: {
        '&&': {
            fontSize: 20,
            marginLeft: 10
        }
    },
    label: {
        '&&': {
            fontFamily: `'Rubik', sans-serif`,
            textAlign: 'right',
            alignSelf: 'flex-start',
            marginBottom: 2
        }
    },
    button: {
        '&&': {
            backgroundColor: '#283136',
            fontFamily: `'Rubik', sans-serif`,
            fontSize: 16,
            borderRadius: 15,
            height: 40,
            width: 110,
            marginTop: 10,
            '&:hover': {
                backgroundColor: '#283136'
            }
        }
    }
})